import { Link } from "react-router-dom";
import { buttonVariants } from "@/components/ui/button";

export default function ApprovalMissing({ id }: { id: string }) {
  // The identifier is the only value this surface displays, so an unknown one
  // must read as an honest dash next to the reason — never as a blank pair of
  // quotes, which looks like a value the product simply failed to print.
  const displayId = id?.trim() ? id : "—";
  return (
    <div className="mx-auto mt-10 max-w-[520px] rounded-lg border border-line bg-surface p-6 text-center">
      <span aria-hidden className="text-2xl">🔍</span>
      <h1 className="mt-2 text-lg font-bold text-ink">Approval item not found</h1>
      <p className="mx-auto mt-1 max-w-[380px] text-[12.5px] leading-relaxed text-muted">
        No details are available for “{displayId}”. Only transfer approvals include an interactive detail view.
      </p>
      <div className="mt-4">
        <Link to="/approvals" className={buttonVariants({ variant: "primary" })}>
          Back to Approvals
        </Link>
      </div>
    </div>
  );
}